var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "960" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("add-filter")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: {
                      model: _vm.model,
                      value: _vm.value.Field,
                      browse: _vm.browse,
                      "is-filter": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onColumnSelect($event)
                      },
                    },
                  }),
                ],
                1
              ),
              !_vm.isNamedFilter
                ? _c(
                    "w-scroll-view",
                    {
                      attrs: {
                        tag: "w-col",
                        "tag-attributes": { xs: 12, md: 6, noMargin: true },
                      },
                    },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.operators,
                              label: _vm.$ct("operator"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.value.Operator,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "Operator", $$v)
                              },
                              expression: "value.Operator",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.selectedField
                        ? _c("app-asked-filter-edit-value", {
                            attrs: {
                              "field-type": _vm.fieldType,
                              filter: _vm.value,
                            },
                          })
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            staticClass: "mb",
                            attrs: { label: _vm.$ct("is-or") },
                            model: {
                              value: _vm.value.IsOr,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "IsOr", $$v)
                              },
                              expression: "value.IsOr",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mb",
                            attrs: { label: _vm.$ct("is-optional") },
                            model: {
                              value: _vm.value.IsOptional,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "IsOptional", $$v)
                              },
                              expression: "value.IsOptional",
                            },
                          }),
                          _vm.selectedFieldType == "date"
                            ? _c("w-checkbox", {
                                staticClass: "mb",
                                attrs: {
                                  label: _vm.$ct("use-current-book-year"),
                                },
                                model: {
                                  value: _vm.value.UseCurrentBookYear,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.value,
                                      "UseCurrentBookYear",
                                      $$v
                                    )
                                  },
                                  expression: "value.UseCurrentBookYear",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "w-scroll-view",
                    {
                      attrs: {
                        tag: "w-col",
                        "tag-attributes": { xs: 12, md: 6, noMargin: true },
                      },
                    },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            staticClass: "mb",
                            attrs: { label: _vm.$ct("is-or") },
                            model: {
                              value: _vm.value.IsOr,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "IsOr", $$v)
                              },
                              expression: "value.IsOr",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mb",
                            attrs: { label: _vm.$ct("is-optional") },
                            model: {
                              value: _vm.value.IsOptional,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "IsOptional", $$v)
                              },
                              expression: "value.IsOptional",
                            },
                          }),
                          _c("app-custom-filter-selector", {
                            attrs: { model: _vm.model, value: _vm.value },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.confirmDisabled, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }